import { Enumify } from "enumify-ts";
class VehicleHireLocationType extends Enumify() {
    description;
    static STARTING = new VehicleHireLocationType("Starting Location");
    static DELIVERY = new VehicleHireLocationType("Deliver To");
    static _ = VehicleHireLocationType._closeEnum();
    constructor(description) {
        super();
        this.description = description;
    }
}
export default VehicleHireLocationType;
